import React from 'react';
import { motion } from 'framer-motion';
import StickyNavbar from '../navbar';
import { Link } from 'react-router-dom';
import doctors from '../images/doctors.svg';
import help from '../images/help.svg';

const chapter4 = () => {
  return (
    <div>
      <StickyNavbar />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="bg-white text-black p-4 lg:mt-10 mt-20 md:text-lg sm:p-10 lg:px-20"
      >
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          {/* <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold capitalize">
            Chapter 4: The Research Cycle
          </h1> */}
          <p className="text-[#005FFF] text-2xl py-5">Intended Behavioural Outcome (IBO)</p>
          <p>
            The Community Health Extension Worker (WHO) will begin their research and the research
            cycle (WHAT) by looking at and describing the problem, understanding its causes,
            looking at information that is already available, and narrowing down the question they
            want to ask (HOW). They will work with their fellow colleagues so that they have a
            clear, shared understanding of the health problem (WITH WHOM). These first research
            steps will be carried out within the community and in their places of work, when there
            is a health issue or there is a need to understand an ongoing problem better (WHEN).
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="space-y-8"
        >
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="space-y-3"
          >
            <h2 className="text-xl font-bold mb-2 text-[#005FFF]">What do you want to study?</h2>
            <ul className="list-disc list-inside space-y-3">
              <li>Identifying a problem</li>
              <li>Describing the problem: what it is, the magnitude</li>
              <li>Identifying potential reasons for why the problem exists</li>
              <li>
                What info is available? E.g Literature search, reports, government policies,
                guidelines
              </li>
              <li>Is there an existing solution to the problem? If yes, why isn’t it being used?</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className=" rounded-lg mx-auto p-4"
          >
            {/* <div className="flex justify-center">
              <div className="w-64 h-40 bg-gray-300 rounded-md"></div>
            </div> */}
            <img src={doctors} alt="Doctors" className="w-full mx-auto max-w-md rounded-md" />
            {/* <p className="text-center text-sm text-gray-500 mt-2">Image placeholder</p> */}

          </motion.div>
          <li>Identifying an aspect of the problem to study</li>
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className=" rounded-lg mx-auto p-4"
          >
            {/* <div className="flex justify-center">
              <div className="w-64 h-40 bg-gray-300 rounded-md"></div>
            </div> */}
            <img src={help} alt="help" className="w-full mx-auto max-w-md rounded-md" />
            {/* <p className="text-center text-sm text-gray-500 mt-2">Image placeholder</p> */}

          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            Now that we’ve looked at different types of research (observational, experimental, and
            intervention), we can look in more detail at the steps that make up the research cycle.
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            These stages are common to all research, and thinking about these will help to guide
            you in planning and carrying out health research in the community in a clear and
            organized way, from start to finish.
          </motion.p>
        </motion.div>

        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="flex justify-between mt-10"
        >
          <Link to="/chapter4/video">
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Previous
            </button>
          </Link>
          <Link to="/chapter4/stages">
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Next
            </button>
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default chapter4;
